import { useState } from "react";
import { toast } from "sonner";
import { DataTable } from "@/components/fleet/DataTable";
import { StatusBadge } from "@/components/StatusBadge";
import { Stars } from "@/components/Stars";
import { api, errMsg, fmtDate, kina } from "@/lib/api";
import { usePoll } from "@/lib/usePoll";

const FILTERS = ["", "scheduled", "requested", "accepted", "in_progress", "completed", "cancelled", "expired"];

export const TripsTable = ({ rows, showCustomer, onCancel }) => (
  <DataTable
    testId="bookings-table"
    rows={rows}
    empty="No bookings found."
    cols={[
      ["When", (r) => (r.scheduled_for ? <span title="Scheduled pickup" className="font-semibold text-violet-700">⏰ {fmtDate(r.scheduled_for)}</span> : fmtDate(r.created_at))],
      ...(showCustomer ? [["Passenger", (r) => r.customer_name]] : []),
      ["Route", (r) => <span className="block max-w-[260px] truncate">{r.pickup.address} → {r.dropoff.address}</span>],
      ["Driver", (r) => r.driver_name || "—"],
      ["Taxi", (r) => (r.vehicle ? `#${r.vehicle.taxi_no}` : "—")],
      ["Km", (r) => (r.fare_basis === "gps" ? <span title="Metered by GPS">{r.distance_km} <span className="text-[10px] font-bold text-emerald-600">GPS</span></span> : r.distance_km)],
      ["Fare", (r) => <b className="font-mono-num">{kina(r.fare)}</b>],
      ["Status", (r) => <StatusBadge status={r.status} />],
      ["Rating", (r) => (r.rating ? <Stars value={r.rating} size="h-3 w-3" /> : "—")],
      ...(onCancel
        ? [["", (r) => ["scheduled", "requested", "accepted", "arrived"].includes(r.status) && (
            <button data-testid={`cancel-booking-${r.id}`} onClick={() => onCancel(r.id)} className="text-xs font-semibold text-red-600 hover:underline">Cancel</button>
          )]]
        : []),
    ]}
  />
);

export const BookingsPanel = () => {
  const [status, setStatus] = useState("");
  const [rows, setRows] = useState(null);
  const load = () => api.get("/fleet/bookings", { params: status ? { status } : {} }).then((r) => setRows(r.data)).catch(() => {});
  usePoll(load, 8000, [status]);
  const cancel = async (id) => {
    try {
      await api.post(`/bookings/${id}/cancel`);
      toast.success("Booking cancelled");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {FILTERS.map((f) => (
          <button
            key={f || "all"}
            data-testid={`bookings-filter-${f || "all"}`}
            onClick={() => setStatus(f)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${status === f ? "bg-blue-700 text-white" : "border border-blue-100 bg-white text-slate-600 hover:border-blue-300"}`}
          >
            {f ? f.replace("_", " ") : "All"}
          </button>
        ))}
      </div>
      <TripsTable rows={rows} showCustomer onCancel={cancel} />
    </div>
  );
};
